<div mat-dialog-title class="dialog-header">
    <div>
        <h4 class="modal-title">{{ data.type }} exporteren</h4>
    </div>
    <button aria-label="Close" class="close-button" mat-dialog-close="" tabindex="-1">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

@if (form?.controls?.status) {
    <div mat-dialog-content [formGroup]="form" class="modal-body">
        <div class="d-flex flex-column">
            <div class="d-flex flex-column mb-3" formGroupName="status">
                <b>Welke statussen wil je exporteren?</b>
                @for (status of statusCounts; track status) {
                    <mat-checkbox [formControlName]="status.id.toString()">
                        <div class="d-flex flex-row flex-nowrap align-items-center" style="gap: 0.5rem">
                            <div [innerHTML]="status.count | marker: status.colorcode" class="marker"></div>
                            <span>{{ status.name }}</span>
                        </div>
                    </mat-checkbox>
                }
            </div>

            @if (data.type === 'Pdf') {
                <div class="d-flex flex-column mb-3">
                    <b>Instellingen</b>
                    <mat-checkbox formControlName="workarea_per_page">
                        Plaats ieder werkvak op eigen pagina
                    </mat-checkbox>
                    <mat-checkbox formControlName="include_workarea_table">Tabel met werkvakken opnemen</mat-checkbox>
                </div>

                <div class="d-flex flex-column mb-3">
                    <b>Overzichtskaart van werkvakken</b>
                    <mat-radio-group formControlName="map_type" class="d-flex flex-row justify-content-between">
                        <mat-radio-button value="none">Geen</mat-radio-button>
                        <mat-radio-button value="map">Kaart</mat-radio-button>
                        <mat-radio-button value="satellite">Satelliet</mat-radio-button>
                    </mat-radio-group>
                </div>
            }

            <div class="d-flex flex-column mb-3">
                <b>Sortering werkvakken</b>
                <mat-radio-group
                    [formControl]="$any(form.controls.workarea_sort)"
                    class="d-flex flex-row justify-content-between">
                    <mat-radio-button value="number">Nummer</mat-radio-button>
                    <mat-radio-button value="distance">Afstand</mat-radio-button>
                    <mat-radio-button value="input">Volgens invoer</mat-radio-button>
                </mat-radio-group>
            </div>

            <div class="d-flex flex-column mb-2">
                <b>Filter op werkvaknummers</b>
                <ng-select
                    [items]="filteredWorkareas"
                    formControlName="workarea_ids"
                    [multiple]="true"
                    [searchable]="true"
                    [searchFn]="searchFilteredWorkareas"
                    [closeOnSelect]="false"
                    [clearSearchOnAdd]="true"
                    (paste)="onPaste($event)"
                    appearance="outline"
                    appendTo="body"
                    bindLabel="number"
                    bindValue="id"
                    placeholder="Kies of plak werkvaknummers (leeg = alle werkvakken)">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                        <div
                            class="selected-workareas-list"
                            cdkDropList
                            cdkDropListOrientation="mixed"
                            (cdkDropListDropped)="reorderSelectedWorkareas($event)">
                            @for (item of items; track item.id) {
                                <div class="selected-workarea-chip" cdkDrag>
                                    <span class="selected-workarea-number">{{ item.number }}</span>
                                    <button
                                        type="button"
                                        class="selected-workarea-remove"
                                        (click)="$event.stopPropagation(); clear(item)"
                                        aria-label="Verwijder werkvak">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                            }
                        </div>
                    </ng-template>
                    <ng-template ng-option-tmp let-item="item">
                        <span>
                            {{ item.number }} - {{ item.street }} {{ item.housenumber }}, {{ item.zipcode }}
                            {{ item.place }}
                        </span>
                    </ng-template>
                </ng-select>
            </div>

            @if (data.type === 'Pdf') {
                <div class="d-flex flex-column mb-2">
                    <b>Documenten uit fasen toevoegen</b>
                    <ng-select
                        [items]="availablePhaseDocuments"
                        formControlName="phase_document_reply_ids"
                        [multiple]="true"
                        [placeholder]="
                            availablePhaseDocuments?.length > 0 ? 'Selecteer documenten' : 'Geen documenten beschikbaar'
                        "
                        [closeOnSelect]="false"
                        [clearSearchOnAdd]="true"
                        appearance="outline"
                        appendTo="body"
                        bindLabel="label"
                        bindValue="id">
                    </ng-select>
                </div>

                @if (availableReports?.length > 0) {
                    <div class="d-flex flex-column mb-3">
                        <b>PDF's van boorraport toevoegen</b>
                        <ng-select
                            [items]="availableReports"
                            formControlName="report_files"
                            [multiple]="true"
                            [closeOnSelect]="false"
                            [clearSearchOnAdd]="true"
                            appearance="outline"
                            appendTo="body"
                            placeholder="Selecteer boorraport PDFs">
                        </ng-select>
                    </div>
                }

                @if ((Functionalities.GeoManage | hasFunctionality) && pdfStyles.length > 0) {
                    <div class="d-flex flex-column">
                        <b>PDF-stijl</b>
                        <div class="d-flex flex-row align-items-center" style="gap: 0.5rem">
                            <mat-form-field appearance="outline" class="flex-grow-1">
                                <mat-label>Kies een PDF-stijl</mat-label>
                                <mat-select formControlName="pdf_style_key">
                                    @for (style of pdfStyles; track style) {
                                        <mat-option [value]="style.key">{{ style.name }}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            @if (data.customer) {
                                <button
                                    (click)="saveAsDefault()"
                                    color="primary"
                                    mat-stroked-button
                                    type="button"
                                    class="pdf-style-button"
                                    [disabled]="isAlreadyDefault"
                                    [matTooltip]="'Zet als standaard voor ' + data.customer.name">
                                    <i class="fa-solid fa-thumbtack"></i>
                                </button>
                            }
                        </div>
                    </div>
                }
            }
        </div>
    </div>
}

<div mat-dialog-actions class="modal-footer">
    <button mat-dialog-close color="primary" mat-button type="button">Sluiten</button>
    <div class="spacer"></div>
    <button (click)="download()" color="primary" mat-raised-button type="button" [disabled]="!canDownload">
        Downloaden
    </button>
</div>
